import React from 'react';
import { Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { connect } from 'react-redux';

const VdsContentPage = ({ rendering, overlay }) => {
  const interstitial = overlay?.interstitial;

  const isValidInterstitial = () => {
    const componentNames = rendering.placeholders['content-overlays'].map(c => c.componentName);
    return componentNames.includes(overlay?.type);
  };

  return (
    <>
      <div style={{ display: interstitial && isValidInterstitial() ? 'none' : '' }}>
        <Placeholder name="content-navigation" rendering={rendering} />
        <Placeholder name="content-main" rendering={rendering} />
        <Placeholder name="content-footer" rendering={rendering} />
      </div>
      <Placeholder name="content-overlays" rendering={rendering} />
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    overlay: state.appState?.overlay,
  };
};
export default connect(mapStateToProps)(VdsContentPage);
